import React, { lazy, Suspense } from 'react';
import { CircularProgress, Box } from '@material-ui/core';

import { Dashboard as DashboardLayout } from '../../layouts';
import { TabsURL } from '../../helpers/enums';
import TabPermissions from '../../components/TabPermissions/TabPermissions';

const FaqManager = lazy(() => import('./components/Faq/FaqManager'));

const FaqLoading = (
  <Box display="flex" justifyContent="center" p={6}>
    <CircularProgress />
  </Box>
);

function FaqManagerWithSuspense() {
  return (
    <Suspense fallback={FaqLoading}>
      <FaqManager />
    </Suspense>
  );
}

export const tabsSetupAreaCliente = Object.freeze({
  [TabsURL.AREA_CLIENTE__FAQ]: {
    component: <FaqManagerWithSuspense />,
    label: 'FAQ',
  },
});

function SetupAreaCliente() {
  return (
    <DashboardLayout title="Área do Cliente">
      <TabPermissions tabs={tabsSetupAreaCliente} />
    </DashboardLayout>
  );
}

export default SetupAreaCliente;
